module.exports = __webpack_public_path__ + "img/hot.c5bdea51.svg";